import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import './styles/shop.css';
import { TranslationProvider } from './context/TranslationContext.tsx';
//import { ShopAuthProvider } from './context/ShopAuthContext.tsx'; // Create this
//import { AdminAuthProvider } from './admin/context/AdminAuthContext.tsx'; // Create this
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AdminAuthProvider } from './admin/context/AdminAuthContext.tsx';
import { ShopAuthProvider } from './context/ShopAuthContext.tsx';
polyfillCountryFlagEmojis();

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            gcTime: 10 * 60 * 1000,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
            retry: 1,
        },
    },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    //<React.StrictMode>
    <BrowserRouter>
        <TranslationProvider>
            <QueryClientProvider client={queryClient}>
                <ShopAuthProvider>
                    <AdminAuthProvider>
                        <App />
                    </AdminAuthProvider>
                </ShopAuthProvider>
            </QueryClientProvider>
        </TranslationProvider>
    </BrowserRouter>
    //</React.StrictMode>
);